<template>
  <v-dialog
    v-model="dialog"
    width="60rem"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card scrollable v-if="invoice !== null">
      <v-toolbar color="primary" flat>
        <v-toolbar-title>
          {{ invoice.usluga }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="close_dialog()"><v-icon>mdi-share</v-icon></v-btn>
          <v-btn icon @click="close_dialog()"
            ><v-icon>mdi-printer</v-icon></v-btn
          >
          <v-btn icon @click="close_dialog()"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Usluga</v-list-item-subtitle>
              <v-list-item-title>{{ invoice.usluga }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Klijent</v-list-item-subtitle>
              <v-list-item-title>{{ invoice.klijent }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Cijena</v-list-item-subtitle>
              <v-list-item-title>{{ invoice.cijena }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Mjesec plaćaanja</v-list-item-subtitle>
              <v-list-item-title>{{ invoice.mjesecplacanja }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>Napomena</v-list-item-subtitle>
              <v-list-item-title>{{ invoice.napomena }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <v-progress-circular indeterminate v-else></v-progress-circular>
  </v-dialog>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
    close: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
      invoice: null,
    };
  },
  watch: {
    id: {
      handler() {
        if (this.id !== null) {
          this.dialog = true;
          this.get_invoice();
        } else {
          this.dialog = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    get_invoice() {
      this.$http.get("/usluge/" + this.id).then((resp) => {
        this.invoice = resp.data.result[0];
      });
    },
    close_dialog() {
      if (this.close !== null) {
        this.$webpageEventBus.$emit(this.close);
      } else {
        alert("CLose event nije specificiran!");
      }
    },
  },
};
</script>
